const capitalizeFirstLetter = (value) => value.charAt(0).toUpperCase() + value.slice(1);
export default capitalizeFirstLetter;
//# sourceMappingURL=capitalizeFirstLetter.js.map